// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./web/static/css/app.sass
// module id = 124
// module chunks = 0